<div class="component-container flex flex-col justify-center items-center w-full">
  <div class="heading w-full flex flex-row justify-start">
    Session Settings
  </div>
  <hr class="hr w-full">
  <div class="message">
    Change the session dates below if necessary, then click submit, weeks are
    calculated based on the start date.
    Scheduled sessions are green, Click on a scheduled session to remove it and
    click on a desired day to add it.
  </div>
  <div class="scheduler">
    <app-session-scheduler
      [startDateTime]="startDateTime"
      [previousSessionsList]="sessionList"
      [resetSessionsList]="resetSessionsList"
      [disabled]="!editable || saveButtonLoading"
    ></app-session-scheduler>
    <hr
      class="w-full text-cool-grey mt-[1.6rem]"
      *ngIf="editable && noOfWeeks !== 52 && !saveButtonLoading"
    >
    <div
      class="add-user flex flex-row
      justify-center items-center
      space-x-[1rem] mt-[1rem] mb-[1rem]"
      *ngIf="editable && noOfWeeks !== 52 && !saveButtonLoading"
    >
      <app-icon
        class="icon cursor-pointer"
        [svgIcon]="'add'"
        (click)="addWeek()"
      >
      </app-icon>
      <span
        (click)="addWeek()"
        class="text-cool-grey"
      >Add Week</span>
    </div>
  </div>
  <hr class="w-full">
  <div class="action-center w-full flex flex-row justify-end space-x-[2rem]">
    <app-primary-button
      class="edit-btn"
      type="small"
      (handleClick)="back()"
      [isDisabled]="saveButtonLoading"
    >
      Back
    </app-primary-button>
    <app-primary-button
      class="edit-btn"
      type="small"
      (handleClick)="(!editable || saveButtonLoading) ? edit() : save()"
      [isLoading]="saveButtonLoading"
    >
      {{!editable || saveButtonLoading ? 'Edit' : 'Save'}}
    </app-primary-button>
  </div>
</div>
